import Login from "../pages/auth/Login";
import NotFoundPage from "../pages/NotFound";
import Layout from "../components/Layout";
import { Navigate } from "react-router-dom";
import Dashboard from "../pages/dashboard/Dashboard";

import Wallet from "../pages/wallet/Wallet";
import Roi from "../pages/Roi/Roi";

import Transfer from "../pages/Transfer/Transfer";
import UserToUser from "../pages/Transfer/UserToUser";
import UserToUserHistory from "../pages/Transfer/UserToUserHistory";

import IncomeData from '../pages/Income/IncomeData'
import IncomeDetails from "../pages/Income/IncomeDetails";

import ExpenseData from '../pages/Expense/ExpenseData'
import ExpenseDetails from "../pages/Expense/ExpenseDetails";

import Agent from "../pages/agents/agent";
import ProfitLoss from "../pages/agents/winLoss";
import ProfitLossEntry from "../pages/agents/winLossEntry";
import AddNewAgent from "../pages/agents/addnewAgent";
import ViewAgent from "../pages/agents/viewAgent";
import TransferData from "../pages/Transfer/TransferData";
import TransactionTypes from "../pages/agents/Transaction";
import AgentRemainList from "../pages/Transfer/AgentRemainList";

import User from "../pages/userData/User";
import FundManagement from "../pages/userData/FundManagement";
import ProfitSharing from "../pages/userData/ProfitSharing";
import Transactions from "../pages/userData/Transactions";

import Result from "../pages/agents/Result";
import ResultCopy from "../pages/agents/ResultCopy";
import GameType from "../pages/gameData/GameType";
import ProfitSharingForAll from "../pages/userData/ProfitShareForAll";

import Trace from "../pages/trace/Trace";


export const routes = [
    {
        name: '',
        path: '/',
        element: <Layout />,
        children:  [
            {
                path: '/',
                element: <Navigate to="/dashboard"/>
            },
            {   index: true,
                name: 'Dashboard',
                path: '/dashboard',
                element: <Dashboard />,

            },
            {
                name:'Wallet',
                path:'/wallet',
                element:<Wallet />
            },
            {
                name:'Roi',
                path:'/roi',
                element:<Roi />
            },
            {
                name:'AgentRemainList',
                path:'/agent-remain-list',
                element:<AgentRemainList />
            },
            {
                name:'Transfer',
                path:'/transfer',
                element:<Transfer/>
            },
            {
                name:'UserToUser',
                path:'/user-to-user',
                element:<UserToUser/>
            },
            {
                name:'UserToUserHistory',
                path:'/user-to-user-history',
                element:<UserToUserHistory />
            },
            {
                name:'TransferHistory',
                path:'/transfer-history',
                element:<TransferData />
            },
            {
                name:'Income',
                path:'/income',
                element:<IncomeData/>
            },
            {
                name:'IncomeDetails',
                path:'/income-details',
                element:<IncomeDetails/>
            },
            {
                name:'Expense',
                path:'/expense',
                element:<ExpenseData/>
            },
            {
                name:'ExpenseDetails',
                path:'/expense-details',
                element:<ExpenseDetails/>
            },
            {
                name:'TransactionTypes',
                path:'/transaction-types',
                element:<TransactionTypes />
            },
            {
                name:'Agent',
                path:'/agent',
                element:<Agent/>
            },
            {
                name:'ViewAgent',
                path:'/viewAgent',
                element:<ViewAgent/>
            },
            {
                name:'ViewAgent',
                path:'/viewAgent/:id',
                element:<ViewAgent/>
            },
            // {
            //     name:'Profit&Loss',
            //     path:'/profit-loss',
            //     element:<ProfitLoss/>
            // },
            {
                name:'Profit&LossEntry',
                path:'/profit-loss-entry',
                element:<ProfitLossEntry/>
            },
            {
                name:'AddNewAgent',
                path:'/addnewagent',
                element:<AddNewAgent />
            },
            {
                name: 'User',
                path: '/user',
                element: <User />
            },
            {
                name: 'FundManagement',
                path: '/user/fund-management',
                element: <FundManagement />
            },
            {
                name: 'ProfitSharing',
                path: '/user/profit-sharing',
                element: <ProfitSharing />
            },
            {
                name: 'ProfitSharingForAll',
                path: '/user/profit-sharing/for-all',
                element: <ProfitSharingForAll />
            },
            {
                name: 'Transactions',
                path: '/user/transactions',
                element: <Transactions />,

            },
            // {
            //     name: 'Result',
            //     path: '/result',
            //     element: <Result />
            // },
            {
                name: 'Result & Copy',
                path: '/result-copy',
                element: <ResultCopy />
            },
            // {
            //     name: 'Trace',
            //     path: '/trace',
            //     element: <Trace />
            // },
            {
                name :'404',
                path:'*',
                element : <NotFoundPage />
            },
            {
                name: 'BusinessType',
                path: 'business-type',
                element: <GameType />
            }
        ]
    },
    {
        name: 'Login',
        path: '/login',
        element: <Login />
    },

];
